import { ReceiversI } from '../interfaces/receivers.interface'
import { ReceiversService } from '../services/receivers.service'
import {
    ReceiverPayloadT,
    ReceiversCreateReceiverResponseT,
    ReceiversGetListResponseT,
    ReceiversSearchParamT,
    ReceiversSearchReceiverResponseT,
} from '../types/receivers.types'
import { AdditionalServicesI, AdditionalServicesLTLI } from '@/core/types/additional_services.types'

const receiversService = new ReceiversService()

class ReceiversRealisation implements ReceiversI {
    getList(
        page: number,
        sender_city_id: number,
        company_id: number
    ): Promise<ReceiversGetListResponseT> {
        return receiversService.getList(page, sender_city_id, company_id)
    }

    getListWithoutCityId(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<ReceiversGetListResponseT> {
        return receiversService.getListWithoutCityId(page, company_id, city_id)
    }

    getListFtl(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<ReceiversGetListResponseT> {
        return receiversService.getListFtl(page, company_id, city_id)
    }

    createReceiver(payload: ReceiverPayloadT): Promise<ReceiversCreateReceiverResponseT> {
        return receiversService.createReceiver(payload)
    }

    updateReceiver(
        id: number,
        payload: ReceiverPayloadT
    ): Promise<ReceiversCreateReceiverResponseT> {
        return receiversService.updateReceiver(id, payload)
    }

    updateAdditionalServices(id: number, payload: AdditionalServicesLTLI): Promise<void> {
        return receiversService.updateAdditionalServices(id, payload)
    }

    updateReceiverInOrder(id: number, payload: ReceiverPayloadT): Promise<void> {
        return receiversService.updateReceiverInOrder(id, payload)
    }

    deleteReceiver(id: number): Promise<void> {
        return receiversService.deleteReceiver(id)
    }

    searchReceiver(params: ReceiversSearchParamT): Promise<ReceiversSearchReceiverResponseT> {
        return receiversService.searchReceiver(params)
    }
}

export const receivers = new ReceiversRealisation()
